"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Container = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _pclnIcons = require("pcln-icons");

var _Heading = _interopRequireDefault(require("../../../text/Heading6"));

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _GuestText = _interopRequireDefault(require("../GuestText"));

var _HotelContext = _interopRequireDefault(require("../../../../context/HotelContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-0"
})(["width:100%;background-color:", ";border-top:1px solid ", ";padding:", "px ", "px;flex-direction:column;align-items:center;", "{align-items:flex-start;padding:", "px;flex-direction:row;justify-content:flex-start;}"], (0, _pclnDesignSystem.getPaletteColor)('background.light'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.xl'), (0, _themeGet.themeGet)('space.3'));
exports.Container = Container;
var StyledGuestText = (0, _styledComponents["default"])(_GuestText["default"]).withConfig({
  componentId: "sc-1da74z3-1"
})(["text-align:center;font-size:", "px;margin:", "px;"], (0, _themeGet.themeGet)('fontSizes.2'), (0, _themeGet.themeGet)('space.1'));
var StyledSubheadingText = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  componentId: "sc-1da74z3-2"
})(["font-size:", "px;margin:", "px;"], (0, _themeGet.themeGet)('fontSizes.2'), (0, _themeGet.themeGet)('space.1'));
var LeftFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-3"
})(["align-items:center;margin-bottom:", "px;", "{margin-bottom:0px;}"], (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('mediaQueries.xl'));
var RightFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-4"
})(["margin-left:0px;height:100%;border-left:none;", "{margin-left:16px;border-left:1px solid ", ";}"], (0, _themeGet.themeGet)('mediaQueries.xl'), (0, _pclnDesignSystem.getPaletteColor)('border.base'));
var DateFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-5"
})(["align-items:center;min-width:102px;margin:0px 4px;text-align:center;"]);
var DayFlex = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  componentId: "sc-1da74z3-6"
})(["font-size:", "px;margin:4px;"], (0, _themeGet.themeGet)('fontSizes.2'));
var TimeFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-7"
})(["font-size:", "px;"], (0, _themeGet.themeGet)('fontSizes.0'));
var StyledInfoFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-8"
})(["padding:0px ", "px;"], (0, _themeGet.themeGet)('space.3'));
var StyledInfoFlexMiddle = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1da74z3-9"
})(["border-left:1px solid ", ";border-right:1px solid ", ";padding:0px ", "px;"], (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _pclnDesignSystem.getPaletteColor)('border.base'), (0, _themeGet.themeGet)('space.3'));

var InfoFlex = function InfoFlex(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react["default"].createElement(StyledInfoFlex, _extends({
    flexDirection: "column",
    alignItems: "center"
  }, props), children);
};

var InfoFlexMiddle = function InfoFlexMiddle(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react["default"].createElement(StyledInfoFlexMiddle, _extends({
    flexDirection: "column",
    alignItems: "center"
  }, props), children);
};

var RenderTime = function RenderTime(_ref3) {
  var time = _ref3.time;
  return typeof time === 'string' && _react["default"].createElement(TimeFlex, {
    bold: true
  }, "at ", time);
};

function HotelItinerary(_ref4) {
  var className = _ref4.className;

  var _useContext = (0, _react.useContext)(_HotelContext["default"]),
      checkInDate = _useContext.checkInDate,
      checkOutDate = _useContext.checkOutDate,
      checkInTime = _useContext.checkInTime,
      checkOutTime = _useContext.checkOutTime,
      nights = _useContext.nights,
      rooms = _useContext.rooms,
      adults = _useContext.adults,
      children = _useContext.children;

  return _react["default"].createElement(Container, {
    className: className
  }, _react["default"].createElement(LeftFlex, null, _react["default"].createElement(DateFlex, {
    flexDirection: "column"
  }, _react["default"].createElement(_Heading["default"], {
    subdued: true
  }, "CHECK-IN"), _react["default"].createElement(DayFlex, {
    bold: true
  }, checkInDate), _react["default"].createElement(RenderTime, {
    time: checkInTime
  })), _react["default"].createElement(_pclnIcons.ArrowRight, {
    size: 20,
    mx: 2
  }), _react["default"].createElement(DateFlex, {
    flexDirection: "column"
  }, _react["default"].createElement(_Heading["default"], {
    subdued: true
  }, "CHECK-OUT"), _react["default"].createElement(DayFlex, {
    bold: true
  }, checkOutDate), _react["default"].createElement(RenderTime, {
    time: checkOutTime
  }))), _react["default"].createElement(RightFlex, null, _react["default"].createElement(InfoFlex, null, _react["default"].createElement(_Heading["default"], {
    subdued: true
  }, "NIGHTS"), _react["default"].createElement(StyledSubheadingText, {
    bold: true
  }, nights)), _react["default"].createElement(InfoFlexMiddle, null, _react["default"].createElement(_Heading["default"], {
    subdued: true
  }, "ROOMS"), _react["default"].createElement(StyledSubheadingText, {
    bold: true
  }, rooms)), _react["default"].createElement(InfoFlex, null, _react["default"].createElement(_Heading["default"], {
    subdued: true
  }, "GUESTS"), _react["default"].createElement(StyledGuestText, {
    adults: adults,
    children: children
  }))));
}

HotelItinerary.displayName = 'HotelItinerary';
HotelItinerary.propTypes = {
  className: _propTypes["default"].string
};
HotelItinerary.defaultProps = {
  className: ''
};

var _default = (0, _react.memo)(HotelItinerary);

exports["default"] = _default;